var map = {
	"./portadas_version_escritorio/Semar.jpg": "6fca",
	"./portadas_version_escritorio/Simar.jpg": "1a37",
	"./portadas_version_escritorio/articulo-1.jpg": "7c0d",
	"./portadas_version_escritorio/articulo-2.jpg": "1ed2",
	"./portadas_version_escritorio/comunicado.jpg": "8e6f",
	"./portadas_version_escritorio/infografia-sargazo-2.jpg": "7c39",
	"./portadas_version_escritorio/infografia-sargazo.jpg": "5113",
	"./portadas_version_escritorio/nota-sargazo.jpg": "3c76",
	"./portadas_version_escritorio/presentacion-1.png": "1881b",
	"./portadas_version_escritorio/presentacion-2.png": "2845",
	"./portadas_version_escritorio/presentacion-3.png": "4eca",
	"./portadas_version_escritorio/presentacion-4.png": "ac14",
	"./portadas_version_escritorio/presentacion-5.png": "5d13",
	"./portadas_version_escritorio/presentacion-sargazo.jpg": "fcd1",
	"./portadas_version_escritorio/sargazo-logohome.jpg": "7148",
	"./portadas_version_movil/Semar.jpg": "b809",
	"./portadas_version_movil/Simar.jpg": "e8b6",
	"./portadas_version_movil/Simasar.jpg": "43bd",
	"./portadas_version_movil/comunicado.jpg": "990d",
	"./portadas_version_movil/infografia-sargazo-2.jpg": "6f73",
	"./portadas_version_movil/infografia-sargazo.jpg": "3a1e",
	"./portadas_version_movil/nota-cinvestav.jpg": "d870",
	"./portadas_version_movil/nota-sargazo.jpg": "1dc3",
	"./portadas_version_movil/presentacion-1.png": "0158",
	"./portadas_version_movil/presentacion-2.png": "e52c",
	"./portadas_version_movil/presentacion-3.png": "8142",
	"./portadas_version_movil/presentacion-4.png": "6084",
	"./portadas_version_movil/presentacion-5.png": "949b",
	"./portadas_version_movil/presentacion-sargazo.jpg": "92d7",
	"./portadas_version_movil/sargazo-1.jpg": "ecb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "491f";